import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Chrome for the product design canon — v3 daylight editorial. Paper ground,
 * hairline rule, wide-tracked caps. Styled by the `.pd3` scope defined in
 * src/pages/priorities-ai-design/PrioritiesAIDesignLayout.tsx (rendered on the
 * same routes), so it follows daylight in light mode and the canonical dark
 * ramp when the app theme is dark.
 */
export const ProductDesignDocsNav: React.FC = () => {
  return (
    <nav className="pd3 border-b border-[var(--p-hairline)] bg-[var(--p-paper)] font-body">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-[52px] flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <Link
            to="/elevation/design-language"
            className="eyebrow truncate transition-colors hover:!text-[var(--p-ink)]"
          >
            ← Design language
          </Link>
        </div>
        <div className="flex items-center gap-4 sm:gap-6 shrink-0">
          <Link
            to="/elevation/home"
            className="eyebrow whitespace-nowrap transition-colors hover:!text-[var(--p-ink)]"
          >
            Elevation
          </Link>
        </div>
      </div>
    </nav>
  );
};
